import { render, staticRenderFns } from "./ConfirmMarginalityAction.vue?vue&type=template&id=535fe771"
import script from "./ConfirmMarginalityAction.vue?vue&type=script&lang=js"
export * from "./ConfirmMarginalityAction.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMarginalityAction.vue?vue&type=style&index=0&id=535fe771&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports